var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"tile",attrs:{"to":_vm.toLink}},[_c('lazy-image',{staticClass:"tile-background",attrs:{"item":_vm.imageItem,"sizes":"30w","rootMargin":"0px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }